module.exports = __webpack_public_path__ + "static/media/logo_OCB.0013922d.svg";